import { render, staticRenderFns } from "./TestDrivePoints.vue?vue&type=template&id=190c5038&"
import script from "./TestDrivePoints.vue?vue&type=script&lang=js&"
export * from "./TestDrivePoints.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports